import React, { Component } from 'react';
import GovernmentTableBase from './GovernmentTableBase';

const tableHeaders = ['Range', 'Type', 'EE', 'ER', 'Total'];
const loadTableUrl = 'api/GSISTable/load'
const saveTableUrl = 'api/GSISTable/save'
const resetTableUrl = 'api/GSISTable/reset'

export default class GSISTable extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{ minWidth: '500px', width: '100%' }}>
                <div style={{ color: "#606060", marginTop: '1%' }}>
                    <h2>GSIS Table</h2>
                </div>

                <GovernmentTableBase
                    ref={(x) => this.baseTable = x}
                    headers={tableHeaders}
                    loadTableUrl={loadTableUrl}
                    saveTableUrl={saveTableUrl}
                    resetTableUrl={resetTableUrl}
                    year={this.props.year}
                    resetButtonEnable={this.props.resetButtonEnable}
                />
            </div>
        )
    }
}